import Frontpage from "../components/immoapp/Frontpage";
import SavedSearchListContainer from "../components/immoapp/SavedSearchListContainer";
import ExposeListContainer from "../components/immoapp/ExposeListContainer";
import ExposeCalendarContainer from "../components/immoapp/ExposeCalendarContainer";
import ContactContainer from "../components/immoapp/ContactContainer";

export default [
  { path: "/", name: "frontpage", component: Frontpage },
  { path: "/saved-searches", name: "saved-searches", component: SavedSearchListContainer },
  { path: "/exposes", name: "exposes", component: ExposeListContainer },
  { path: "/exposes/:exposeId/calendar", name: "expose-calendar", component: ExposeCalendarContainer },
  { path: "/contact", name: "contact", component: ContactContainer }
  //{ path: "/", name: "frontpage", component: Frontpage },
  //{ path: "/saved-searchs", name: "savedsearch-list", component: SavedSearchListContainer },
  //{ path: "/", name: "expose-list", component: ExposeListContainer },
];
